export const AllNLPMessageTemplates = [
    {
        label: 'H&P - Constitutional',
        content: {
            rules: [{ tagIds: ['9668b9795a28a8d4797b7cafea80f5ad', '26d34cd9e8b4d1f9495292bb881c1504'] }],
            text: 'No recent weight changes, fatigue, weakness, fever, chills, or night sweats.'
        }
    },
    {
        label: 'H&P - CVS',
        content: {
            rules: [{ tagIds: ['1eaacb0f33f2c5e98ee97927be22d8fb'] }],
            text: 'No hypertension, chest pain, palpitations, or edema.'
        }
    },
    {
        label: 'H&P - Respiratory',
        content: {
            rules: [{ tagIds: ['7ebab45a259b91bf397c30f2226c8860'] }],
            text: 'No cough, wheezing, or shortness of breath.'
        }
    },
    {
        label: 'H&P - Skin',
        content: {
            rules: [{ tagIds: ['4121c5148699b707229f2d33fd8b0996'] }],
            text: 'No rashes, itching, lesions, wounds, sores, or skin infections. No history of skin cancer.',
        }
    },
    {
        label: 'H&P - HEENT',
        content: {
            rules: [{ tagIds: ['eeb720f6ce27e36d8a92f77d611d97e5'] }],
            text: 'No headaches, visual disturbances, hearing , nasal  or throat symptoms.'
        }
    },
    {
        label: 'H&P - GIT',
        content: {
            rules: [{ tagIds: ['829d6689fc0901b5002f81173f84c655'] }],
            text: 'No abdominal pain, bloating, nausea, vomiting, or bowel habit changes. No GI disorders.'
        }
    }
];
//# sourceMappingURL=templates.js.map